import { getFirebaseBackend } from 'helpers/firebaseHelper';

const getAccountTeam = (accountId) => {
  const firebaseHelper = getFirebaseBackend();

  return new Promise(async (resolve, reject) => {
    const team = await firebaseHelper.getTeam(accountId);
    if (team) {
      const select = Object.entries(team)
        .filter(([memberId]) => memberId !== 'initialTeamState')
        .map(([accountId, memberInfo]) => ({
          value: memberInfo.id,
          label: `${memberInfo.name} ${memberInfo.lastName}`,
        }));
      resolve(select);
    }
  });
};

export { getAccountTeam };
